/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
    Container,
    Row,
    Col,
} from "reactstrap";

// core components
import {Translate} from "components/i18n/index.js";
import {ContactUs} from "components/ContactUs";

import './style.scss';
import {apNamespace, apStaticMode} from "../../services/http";
import PerpalTermsAndConditions from "../../contents/perpal/terms";
// import PerpalTermsAndConditionsFa from "../../contents/perpal/terms-fa";
import TermsAndConditions from "../../contents/ap/terms";
// import TermsAndConditionsFa from "../../contents/ap/terms-fa";

class TermsPage extends React.Component {
    state = {
        lang: localStorage.getItem('ap.theme.lang') || 'en',
    };

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        window.addEventListener('lang_changed', this.langChangeHandler);
    }

    componentWillUnmount() {
        window.removeEventListener('lang_changed', this.langChangeHandler);
    }

    render() {
        return (
            <main ref="main" data-page-mode={apStaticMode ? 'static' : 'normal'}>
                <section className="section section-lg section-shaped">
                    <div className="shape shape-style-1 shape-default"/>
                    <Container>
                        <Row className="justify-content-center text-center mb-sm">
                            <Col lg="8">
                                <h2 className="display-3"><Translate>Terms</Translate></h2>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </section>
                <section className="section section-lg">
                    <Container className="main-content">
                        {this.content()}
                    </Container>
                </section>
                {!apStaticMode && <ContactUs/>}
            </main>
        );
    }

    content() {
        const {lang} = this.state;
        if (apNamespace || apStaticMode) {
            // if (lang === 'fa') {
            //     return <PerpalTermsAndConditionsFa/>;
            // }
            return <PerpalTermsAndConditions/>;
        }

        // if (lang === 'fa') {
        //     return <TermsAndConditionsFa/>;
        // }
        return <TermsAndConditions/>;
    }

    langChangeHandler = () => {
        this.setState({
            lang: localStorage.getItem('ap.theme.lang'),
        });
    }
}

export default TermsPage;
